import React from 'react';
import withIcon from '../utilities/withIcon';

const IconShuffle = () => {
  return (
    <g>
      <path d="m15.8811 12.09a.7506.7506 0 0 0 -.1614-.2416l-2.3975-2.397a.75.75 0 0 0 -1.0605 1.0605l1.1167 1.1164h-1.4077l-.0057.0012-.0051-.0012c-1.249.0483-3.4619-.4619-4.6035-3.8662-1.8935-5.6521-6.6357-4.8485-6.6826-4.8378a.75.75 0 0 0 .2685 1.4757c.1406-.023 3.5215-.5513 4.9922 3.8384 1.4688 4.3843 4.6045 4.89 5.9688 4.89h.0779 1.3978l-1.1172 1.1169a.75.75 0 1 0 1.0605 1.0605l2.3975-2.397a.7476.7476 0 0 0 .1614-.819z" />
      <path d="m7.7666 6.523a.747.747 0 0 0 .6034-.3038 4.227 4.227 0 0 1 3.59-1.8472l.0057-.001.0051.001h1.4077l-1.1168 1.1163a.75.75 0 1 0 1.0605 1.0605l2.3978-2.3969a.7513.7513 0 0 0 -.0006-1.0611l-2.3972-2.3965a.75.75 0 1 0 -1.0605 1.0605l1.1173 1.1169h-1.4083a5.8241 5.8241 0 0 0 -4.8057 2.455.75.75 0 0 0 .6016 1.1963z" />
      <path d="m4.9394 9.7544a4.2617 4.2617 0 0 1 -3.9971 1.8456.75.75 0 0 0 -.2676 1.4756 4.2116 4.2116 0 0 0 .7178.0532 5.792 5.792 0 0 0 4.7575-2.4888.75.75 0 0 0 -1.2109-.8857z" />
    </g>
  );
};

export default withIcon(IconShuffle);
